import * as Yup from 'yup'

export const locationsScheme = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  address: Yup.string().required('Address is required'),
  lat: Yup.number()
    .typeError('Latitude must be a number')
    .required('Latitude is required'),
  long: Yup.number()
    .typeError('Longitude must be a number')
    .required('Longitude is required'),
  type: Yup.string().required('Type is required'),
  attributes: Yup.string().required('Attritutes are Reqy=uired'),
  count: Yup.number()
    .typeError('Count must be a number')
    .required('Count is required'),
  categoryId: Yup.string().required('Category is required')
})
